// extracted by mini-css-extract-plugin
export default {"PasswordChecker":"passwordChecker_PasswordChecker__gd8c1","text":"passwordChecker_text__uKURz","errorText":"passwordChecker_errorText__FUt2S"};